// Mismo modelo que Android (LibraryEntry / WatchProgress) y que supabase/migrations.
// updatedAt/deletedAt: epoch en ms; deletedAt != null es un borrado (tombstone) pendiente de propagar.

export type LibraryStatus = "favorite" | "watching" | "finished" | "watchLater";

export const LIBRARY_STATUSES: readonly LibraryStatus[] = ["favorite", "watching", "finished", "watchLater"];

export const STATUS_LABELS: Record<LibraryStatus, string> = {
  favorite: "Favoritos",
  watching: "Viendo",
  finished: "Terminados",
  watchLater: "Ver después",
};

export interface LibraryEntry {
  animeUrl: string;
  provider: string;
  title: string;
  imageUrl: string;
  isFavorite: boolean;
  isWatching: boolean;
  isFinished: boolean;
  isWatchLater: boolean;
  updatedAt: number;
  deletedAt: number | null;
}

export interface WatchProgress {
  episodeUrl: string;
  animeUrl: string;
  animeTitle: string;
  episodeTitle: string;
  imageUrl: string;
  positionMs: number;
  durationMs: number;
  updatedAt: number;
  deletedAt: number | null;
}

/** Fila local con su estado de sincronizacion. */
export type Synced<T> = T & { pending: boolean };

const STATUS_FIELD: Record<LibraryStatus, keyof Pick<LibraryEntry, "isFavorite" | "isWatching" | "isFinished" | "isWatchLater">> = {
  favorite: "isFavorite",
  watching: "isWatching",
  finished: "isFinished",
  watchLater: "isWatchLater",
};

export function hasStatus(entry: LibraryEntry, status: LibraryStatus): boolean {
  return entry[STATUS_FIELD[status]];
}

export function withStatus(entry: LibraryEntry, status: LibraryStatus, enabled: boolean): LibraryEntry {
  return { ...entry, [STATUS_FIELD[status]]: enabled };
}

export function isEmptyEntry(entry: LibraryEntry): boolean {
  return LIBRARY_STATUSES.every((status) => !hasStatus(entry, status));
}

/** Last-write-wins: la escritura remota solo gana si es estrictamente mas nueva. */
export function remoteWins(local: { updatedAt: number } | undefined, remote: { updatedAt: number }): boolean {
  return !local || remote.updatedAt > local.updatedAt;
}
